import React from 'react';

const ConfirmModal = ({ message, onConfirm, onCancel }) => (
  <div
    style={{
      position: 'fixed', inset: 0, zIndex: 1051,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}
    onClick={(e) => { if (e.target === e.currentTarget) onCancel(); }}
  >
    <div style={{
      background: 'white', borderRadius: '12px',
      minWidth: '320px', maxWidth: '420px', width: '90vw',
      boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
      display: 'flex', flexDirection: 'column',
    }}>
      {/* 헤더 */}
      <div style={{
        padding: '14px 20px', borderBottom: '1px solid #dee2e6',
        background: '#f8f9fa', borderRadius: '12px 12px 0 0',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <h5 style={{ margin: 0 }}>확인</h5>
        <button className="btn btn-sm btn-outline-secondary" onClick={onCancel}>✕</button>
      </div>

      {/* 본문 */}
      <div style={{ padding: '20px', lineHeight: '1.6' }}>
        <p style={{ margin: 0, whiteSpace: 'pre-line' }}>{message}</p>
      </div>

      {/* 푸터 */}
      <div style={{
        padding: '12px 16px', borderTop: '1px solid #dee2e6',
        display: 'flex', justifyContent: 'flex-end', gap: '8px',
      }}>
        <button className="btn btn-primary" onClick={onConfirm}>예</button>
        <button className="btn btn-secondary" onClick={onCancel}>아니오</button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
